var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-wave-wrapper"},[_c('audio',{staticClass:"video-js vjs-fill vjs-default-skin",attrs:{"id":"audio-wave"}})])}]

export { render, staticRenderFns }